import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { Stack } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useAuth from "../../../../hooks/useAuth";

const UserConfirmation = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { getEmailConfirmation } = useAuth({
    email: searchParams.get("email") ?? "",
    token: searchParams.get("token") ?? "",
  });
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getEmailConfirmation.refetch();
  }, []);

  useEffect(() => {
    if (getEmailConfirmation.isSuccess) {
      setOpen(true);
    } else if (getEmailConfirmation.isError) {
      // TODO toast message
      handleClose();
    }
  }, [getEmailConfirmation]);

  const handleClose = () => {
    navigate({
      pathname: "/home",
    });
  };

  return (
    <Stack>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          Account <b>{searchParams.get("email") ?? ""}</b> verified
          successfully. You can now log in.
        </DialogTitle>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button variant="contained" onClick={handleClose}>
            Go to Homepage
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
};

export default UserConfirmation;
